import { useEffect } from 'react';

import { useUserContext } from '@/modules/auth/hooks/useUser';
import { useJobByCreatorSubscription } from '@/modules/corporate/modules/bulk-import/graphql/subscription/generated/jobByCreator';
import { JobEntityStatusEnum, JobSubscriptionOperationEnum } from '@/types/schema';

import { UseJobByCreatorSubscriptionProps } from './types';

function useJobByCreatorSubscriptionFn({
  pause,
  onSuccess,
  purpose,
}: UseJobByCreatorSubscriptionProps) {
  const { id } = useUserContext();
  const [{ data, fetching, error }] = useJobByCreatorSubscription({
    variables: {
      input: {
        createdById: id,
        purpose,
        operations: [
          JobSubscriptionOperationEnum.JobCreated,
          JobSubscriptionOperationEnum.JobUpdated,
        ],
      },
    },
    pause: pause || !id,
  });

  useEffect(() => {
    if (data && !error && data.jobByCreator.job.status === JobEntityStatusEnum.Completed) {
      onSuccess?.(data);
    }
  }, [data, error, fetching, onSuccess]);

  return {
    data,
    fetching,
    error,
  };
}

export default useJobByCreatorSubscriptionFn;
